import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { backend } from "../../../../path";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import ScrollToTop from "../../../components/whatsapp connect";
import styled from "styled-components";
import "./Frame1618873127/style.css"; // Adjust the path as necessary
function Login() {
  const [formData, setFormData] = useState([]);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleSubmit = () => {
    if (!formData.email) {
      toast.error("Email is required.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    // Check if email is in valid email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      console.error("Invalid email format.");
      toast.error("Invalid email format.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    // Check if password is not null or empty
    if (!formData.password) {
      console.error("Password is required.");
      toast.error("Password is required.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    fetch(backend + "login", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then(async (response) => {
        let data = null;
        try {
          data = await response.json();
        } catch (error) {
          console.error("Failed to parse login response:", error);
        }

        if (!response.ok) {
          console.error(
            "Failed to Login:",
            response.status,
            response.statusText
          );

          // Check for conflict status (HTTP 409)
          if (response.status === 409) {
            toast.error("Incorrect login details found, please verify your details or create a new account.", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else if (response.status === 410) {
            navigate("/user/reminder");
          } else if (response.status === 401) {
            toast.error("Incorrect login details found, please verify your details or create a new account.", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            console.error("Password Does Not Match");
            toast.error("Password Does Not Match", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          return;
        }

        if (!data || data === "invalid") {
          toast.error("Invalid Credentials", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          return;
        }

        localStorage.setItem("userdata", JSON.stringify(data));
        // navigate("/");
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error during login:", error);
        toast.error("Login failed", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  return (
    <>
      <div class="frame hidden lg:block">
        <div class="div">
          <div class="overlap-group">
            <p class="text-wrapper">Sign in to your account</p>
            <img class="ks" src="/storage/general/ks-logo32-1.png" />
          </div>
          <div className="new-to-kerala">
            <span className="span font-medium">New to Keralaspecial ?</span>
            <button
              onClick={() => typeof window.openAuthModal === "function" ? window.openAuthModal("register") : navigate("/register")}
              className="register-button-link cursor-pointer"
            >
              Create Account
            </button>
          </div>
          <input
            // className=" "
            name="email"
            required
            id="txt-email"
            type="email"
            value={formData.email || ""}
            onChange={(e) =>
              setFormData({
                ...formData,
                email: e.target.value,
              })
            }
            placeholder="Email"
            className="div-wrapper"
          />
          <input
            // className=" "
            type={showPassword ? "text" : "password"}
            name="password"
            value={formData.password || ""}
            onChange={(e) =>
              setFormData({
                ...formData,
                password: e.target.value,
              })
            }
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSubmit();
              }
            }}
            placeholder="Your password"
            className="div-wrapper-2"
          />
          <div
            class="div-wrapper-3 cursor-pointer"
            onClick={handleSubmit}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSubmit();
              }
            }}
          >
            <div class="text-wrapper-4">Sign In</div>
          </div>
          {/* <div class="div-2 cursor-pointer">
            <img
              class="flat-color-icons"
              src="storage/general/flat-color-icons-google.svg"
            />
            <div class="text-wrapper-5">Continue with Google</div>
          </div> */}
          {/* <div class="div-3">
            <img class="line" src="storage/general/line-42.svg" />
            <img class="img" src="storage/general/line-42.svg" />
            <div class="text-wrapper-6">or</div>
          </div> */}
        </div>
        <div class="overlap">
          <img class="ks-logo" src="/storage/general/ks-logo32-1.png" />
        </div>
        <button
          type="button"
          command="close"
          commandfor="dialog"
          class="inline-flex"
        >
          <img
            class="material-symbols"
            src="/storage/general/material-symbols-close.svg"
            command="close"
            commandfor="dialog"
          />
        </button>
      </div>
      <div class="flex block lg:hidden">
        <div class="w-full m-auto rounded p-4">
          <header style={{ justifyItems: "anchor-center" }}>
            <button
              type="button"
              command="close"
              commandfor="dialog"
              class="inline-flex justify-end w-100"
            >
              <img
                class="material-symbols"
                src="/storage/general/material-symbols-close.svg"
                command="close"
                commandfor="dialog"
              />
            </button>
            <img class="ks h-[100px]" src="/storage/general/ks-logo32-1.png" />
            <p class="font-poppins font-bold text-[23px] leading-[100%] tracking-[0%] mt-4 text-[#000000]">
              Sign in to your account
            </p>
            <div className="flex items-center justify-between mt-4 p-3 bg-[#f8f9fa] rounded-xl border border-[#ececec]">
              <span className="font-[Poppins] font-medium text-[14px] text-[#555]">
                New to Kerala Specials?
              </span>
              <button
                onClick={() => typeof window.openAuthModal === "function" ? window.openAuthModal("register") : navigate("/register")}
                className="bg-[#62BC01] text-white px-4 py-2 rounded-lg font-[Poppins] font-semibold text-[13px] hover:bg-[#55a301] shadow-sm transition-all active:scale-95"
              >
                Create Account
              </button>
            </div>
          </header>
          {/* <form> */}
          <div>
            <input
              // className=" "
              required
              id="txt-email"
              type="email"
              value={formData.email || ""}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  email: e.target.value,
                })
              }
              placeholder="Email"
              class="w-full h-[44px] opacity-100 rounded-lg border p-[10px] pl-[17px] bg-white border border-1 border-bg-[#929292] my-2"
            />
            <input
              // className=" "
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password || ""}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  password: e.target.value,
                })
              }
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSubmit();
                }
              }}
              placeholder="Your password"
              class="w-full h-[44px] opacity-100 rounded-lg border p-[10px] pl-[17px] bg-white border border-1 border-bg-[#929292] my-2"
            />
            <div class="h-[20px]">
              <Link class="text-[#DB0F0F] text-sm float-left " to="#">
                Forgot Password?
              </Link>
            </div>
          </div>

          <div
            class="w-full h-[44px] opacity-100 rounded-lg border p-[10px] pl-[17px] bg-[#62BC01] my-2 justify-center"
            onClick={handleSubmit}
            style={{ justifyItems: "anchor-center" }}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSubmit();
              }
            }}
          >
            <div class="font-[Poppins] font-medium text-[16px] leading-[100%] tracking-[0] text-white">
              Sign In
            </div>
          </div>

          <div
            class="w-full h-[44px] opacity-100 rounded-lg border pt-[3px] pl-[17px] bg-[#fff] my-2 justify-center items-center"
          // onClick={handleSubmit}
          // style={{ justifyItems: "anchor-center" }}
          // onKeyDown={(e) => {
          //   if (e.key === "Enter") {
          //     handleSubmit();
          //   }
          // }}
          >
            {/* <div class="font-[Poppins] font-medium text-[16px] leading-[100%] tracking-[0] text-[#000] flex justify-center items-center">
              <svg
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mr-5"
              >
                <path
                  d="M29.9826 13.8071H28.875V13.75H16.5V19.25H24.2708C23.1371 22.4517 20.0908 24.75 16.5 24.75C11.9439 24.75 8.25 21.0561 8.25 16.5C8.25 11.9439 11.9439 8.25 16.5 8.25C18.6031 8.25 20.5164 9.04338 21.9732 10.3393L25.8624 6.45013C23.4066 4.16144 20.1218 2.75 16.5 2.75C8.90656 2.75 2.75 8.90656 2.75 16.5C2.75 24.0934 8.90656 30.25 16.5 30.25C24.0934 30.25 30.25 24.0934 30.25 16.5C30.25 15.5781 30.1551 14.6781 29.9826 13.8071Z"
                  fill="#FFC107"
                />
                <path
                  d="M4.33594 10.1001L8.8535 13.4131C10.0759 10.3867 13.0363 8.25 16.5006 8.25C18.6036 8.25 20.5169 9.04337 21.9738 10.3393L25.8629 6.45012C23.4072 4.16144 20.1223 2.75 16.5006 2.75C11.2192 2.75 6.63906 5.73169 4.33594 10.1001Z"
                  fill="#FF3D00"
                />
                <path
                  d="M16.5007 30.25C20.0523 30.25 23.2795 28.8908 25.7194 26.6805L21.4638 23.0794C20.0371 24.165 18.2934 24.7519 16.5007 24.75C12.9243 24.75 9.88764 22.4695 8.74364 19.2871L4.25977 22.7418C6.53539 27.1947 11.1568 30.25 16.5007 30.25Z"
                  fill="#4CAF50"
                />
                <path
                  d="M29.9826 13.8071H28.875V13.75H16.5V19.25H24.2708C23.7285 20.7738 22.7517 22.1053 21.461 23.0801L21.4631 23.0787L25.7187 26.6798C25.4176 26.9534 30.25 23.375 30.25 16.5C30.25 15.5781 30.1551 14.6781 29.9826 13.8071Z"
                  fill="#1976D2"
                />
              </svg>
              Continue with Google
            </div> */}
          </div>

          <div></div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default Login;
const LoginSec = styled.div`
  form {
    display: grid;
    gap: 20px;
  }
  input {
    padding: 10px;
  }
`;
